<template>
    <div>
        <h2 class="sim-h3 mb-8">
            {{ $t('product.related_products') }}
        </h2>
        <SwiperCarousel :slides="products.length ? products : Array.from({ length: 10 }, () => null)">
            <template #slide="{ slide: product }">
                <ProductCard
                    :product="product"
                    :loading="!products.length"
                />
            </template>
        </SwiperCarousel>
    </div>
</template>

<script setup lang="ts">

const {
    products,
} = defineProps<{
    products: InstanceType<typeof ProductModel>[]
}>()

</script>
